import React, {Component} from 'react'
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Input,
    Row,
    Col,
    Label,
    FormGroup
} from 'reactstrap'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import {Query, Mutation} from 'react-apollo'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import query from "../../../queries/server/project_supplier_invoice"
import mutation from '../../../queries/server/mutations/create_project_client_invoice'
import localMutation from '../../../queries/client_side/mutations/edit_project_supplier_invoice'
import {AvForm, AvField} from 'availity-reactstrap-validation'
import Loading from "../Loading";
import AUSelectGenerator from '../../components/auto_updaters/ValidSelect'

const AUSelectSuppliers = AUSelectGenerator('suppliers', 'client_id name', 'client_id', ['name'])

export default class ProjectSupplierInvoiceInput extends Component {

    constructor(props) {
        super(props)
        this.file = null
    }

    state = {
        client_id: null,
        type_id: 3,
        invoice_prefix: '',
        invoice_no: '',
        created_at: null,
        issued_at: null,
        paid_at: null,
        file: null
    }


    reset = () => {
        this.setState({
            client_id: null,
            invoice_prefix: '',
            invoice_no: '',
            created_at: null,
            issued_at: null,
            paid_at: null,
            file: null
        })
    }

    render() {
        const {isOpen, toggle, onSave, project_id} = this.props

        if (!isOpen) return null

        return (
            <Query query={query} variables={{project_id}} fetchPolicy="network-only">
                {({data, loading}) => {

                    if (loading) return (
                        <Modal isOpen={isOpen} toggle={toggle} size="xl">
                            <ModalHeader>{project_id}</ModalHeader>
                            <ModalBody>
                                <Loading/>
                            </ModalBody>
                        </Modal>
                    )


                    const {name, project_activity_budgets} = data.projectSupplierInvoice
                    const {invoice_prefix, invoice_no, created_at, issued_at, paid_at, client_id, type_id} = this.state

                    return (

                        <Mutation mutation={mutation}>
                            {(mutationFunc, {loading}) => (


                                <Mutation mutation={localMutation}>
                                    {(localMutationFunc) => (

                                        <Modal isOpen={isOpen} toggle={() => {
                                            toggle()
                                            this.reset()
                                        }} size="xl">
                                            <AvForm
                                                
                                                onValidSubmit={() => {

                                                    const {file} = this
                                                    mutationFunc({
                                                        variables: {
                                                            project_id,
                                                            data: [
                                                                {
                                                                    invoice_prefix,
                                                                    invoice_no,
                                                                    created_at,
                                                                    issued_at,
                                                                    paid_at,
                                                                    client_id,
                                                                    project_id,
                                                                    type_id,
                                                                    file,
                                                                    breakdown: project_activity_budgets
                                                                        .map(({project_activity_type, amount_to_invoice, project_activity_budget_id, budget_label}) => {
                                                                            return {
                                                                                description: budget_label,
                                                                                amount: amount_to_invoice,
                                                                                project_activity_budget_id
                                                                            }
                                                                        })
                                                                }
                                                            ]
                                                        }
                                                    })
                                                        .then(({data}) => {
                                                            console.log('the data', data)
                                                            if (onSave) onSave(data.createProjectClientInvoice)
                                                            this.reset()
                                                        })

                                                }}
                                            >
                                                <ModalHeader>{project_id}: {name}</ModalHeader>
                                                <ModalBody>
                                                    <div>
                                                        <div>
                                                            <div>
                                                                <Row form>
                                                                    <Col>
                                                                        <AUSelectSuppliers
                                                                            required
                                                                            errorMessage="Required"
                                                                            label="Supplier*"
                                                                            name="client_id"
                                                                            bsSize="sm"
                                                                            value={client_id}
                                                                            onChange={(client_id) => this.setState({client_id})}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                                <Row form>
                                                                    <Col sm="3">
                                                                        <AvField
                                                                            required
                                                                            name={`invoice_prefix`}
                                                                            bsSize="sm"
                                                                            label="Quote/Invoice Prefix"
                                                                            value={invoice_prefix}
                                                                            onChange={(evt) => {
                                                                                this.setState({invoice_prefix: evt.target.value})
                                                                            }}

                                                                        />
                                                                    </Col>
                                                                    <Col sm="9">
                                                                        <AvField
                                                                            name={`invoice_no`}
                                                                            bsSize="sm"
                                                                            label="Quote/Invoice Number"
                                                                            value={invoice_no}
                                                                            onChange={(evt) => {
                                                                                this.setState({invoice_no: evt.target.value})
                                                                            }}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                                <Row form>
                                                                    <Col sm="4">
                                                                        <AvField
                                                                            name={`invoice_date`}
                                                                            bsSize="sm"
                                                                            type="date"
                                                                            label="Quote/Invoice Date"
                                                                            value={created_at}
                                                                            onChange={(evt) => {
                                                                                this.setState({created_at: evt.target.value})
                                                                            }}
                                                                        />
                                                                    </Col>

                                                                    <Col sm="4">
                                                                        <AvField
                                                                            name={`issued_date`}
                                                                            bsSize="sm"
                                                                            type="date"
                                                                            label="Issued Date"
                                                                            value={issued_at}
                                                                            onChange={(evt) => {
                                                                                this.setState({issued_at: evt.target.value})
                                                                            }}
                                                                        />
                                                                    </Col>

                                                                    <Col sm="4">
                                                                        <AvField
                                                                            name={`paid_date`}
                                                                            bsSize="sm"
                                                                            type="date"
                                                                            label="Paid Date"
                                                                            value={paid_at}
                                                                            onChange={(evt) => {
                                                                                this.setState({paid_at: evt.target.value})
                                                                            }}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                                <Row form>

                                                                    <Col>
                                                                        <AvField
                                                                            bsSize="sm"
                                                                            type="file"
                                                                            label="Upload File"
                                                                            name={`invoice_file`}
                                                                            onChange={(evt) => {
                                                                                //this.setState('file', evt.target.files[0])
                                                                                this.file = evt.target.files[0]
                                                                            }}
                                                                        />
                                                                    </Col>

                                                                </Row>

                                                                <Label className="mt-3">Budget
                                                                    Items</Label>

                                                                {project_activity_budgets && project_activity_budgets
                                                                    .map((budget, index) => {
                                                                        return (
                                                                            <Row
                                                                                className="pt-2 pb-2"
                                                                                form
                                                                                key={index}>
                                                                                <Col sm="9">
                                                                                    <Input
                                                                                        size="sm"
                                                                                        value={budget.budget_label}
                                                                                        onChange={(evt) => {
                                                                                            localMutationFunc({
                                                                                                variables: {
                                                                                                    project_id,
                                                                                                    project_activity_budget_id: budget.project_activity_budget_id,
                                                                                                    description: evt.target.value,
                                                                                                    amount: budget.amount_to_invoice
                                                                                                }
                                                                                            })
                                                                                        }}
                                                                                    />
                                                                                </Col>
                                                                                <Col sm="3">
                                                                                    <Input
                                                                                        size="sm"
                                                                                        type="number"
                                                                                        value={budget.amount_to_invoice}
                                                                                        min={0}
                                                                                        onChange={(evt) => {
                                                                                            localMutationFunc({
                                                                                                variables: {
                                                                                                    project_id,
                                                                                                    project_activity_budget_id: budget.project_activity_budget_id,
                                                                                                    description: budget.budget_label,
                                                                                                    amount: evt.target.value
                                                                                                }
                                                                                            })
                                                                                        }}
                                                                                    />
                                                                                </Col>
                                                                            </Row>

                                                                        )
                                                                    })}
                                                            </div>


                                                        </div>
                                                    </div>


                                                </ModalBody>
                                                <ModalFooter>
                                                    <Button
                                                        size="sm"
                                                        color="success"
                                                        disabled={loading}
                                                        type="submit"
                                                    >
                                                        <FontAwesomeIcon
                                                            color="#fff"
                                                            icon="save"/>{' '}
                                                        {loading ? 'Saving...' : 'Save'}
                                                    </Button>
                                                </ModalFooter>
                                            </AvForm>
                                        </Modal>

                                    )}
                                </Mutation>


                            )}

                        </Mutation>
                    )

                }}

            </Query>
        )
    }

}

ProjectSupplierInvoiceInput.propTypes = {
    isOpen: PropTypes.bool,
    toggle: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    project_id: PropTypes.string.isRequired
}